"use client"

import { getFixedT } from "@/languages/i18n"
import { Form } from "antd"
import Link from "next/link"

export const PolicyCheckbox: React.FC<{ linkTermsOfService?: string; locale?: string }> = ({ linkTermsOfService, locale }) => {
    const t = getFixedT(locale)
    return (
        <Form.Item
            name="policy"
            className="mt-5"
            valuePropName="checked"
            rules={[
                {
                    validator: (_, value) =>
                        value
                            ? Promise.resolve()
                            : Promise.reject(new Error(t("You must accept our terms of service and Privacy Policy"))),
                },
            ]}
        >
            <div className="flex items-center justify-center gap-3">
                <input
                    type="checkbox"
                    className="h-4 w-4 rounded border-gray-300 text-[#00A651] focus:ring-[#00A651]"
                />
                <p className="text-sm text-black font-medium leading-[21.7px]">
                    {t("I agree with")}{" "}
                    <Link href={linkTermsOfService || "/"} target="_blank" className="text-[#18AF4E] hover:text-[#1EAD46]">
                        {t("Terms of Service")}
                    </Link>{" "}
                    {t("and")}{" "}
                    <Link href={linkTermsOfService || "/"} target="_blank" className="text-[#18AF4E] hover:text-[#1EAD46]">
                        {t("Privacy Policy")}
                    </Link>
                </p>
            </div>
        </Form.Item>
    )
}

